module.exports = __webpack_public_path__ + "static/media/logo.e777f650.png";